import moment from 'moment';
import {
  GetRejectedGroupedTalentsQueryVariables,
  SearchEntityTagOperatorEnum,
  SearchUserEntityTagInput,
  UserSearchEntityTagNameEnum,
} from '@src/graphql/generated';
import { GroupedTalentDictionaryKey } from './enums/groupedTalentDictionaryKey.enum';

export const TWO_WEEKS_BEFORE_TODAY = moment().subtract(44, 'days').toISOString();
export const SEVEN_DAYS_BEFORE_TODAY = moment().subtract(7, 'days').toISOString();

export const GROUPED_TALENT_DICTIONARY: Record<
  GroupedTalentDictionaryKey.RECENTLY_JOINED | GroupedTalentDictionaryKey.RECENTLY_ACTIVE,
  SearchUserEntityTagInput[]
> = {
  [GroupedTalentDictionaryKey.RECENTLY_JOINED]: [
    {
      operator: SearchEntityTagOperatorEnum.GT,
      tag: UserSearchEntityTagNameEnum.VERIFICATION_PUBLISHED_AT,
      value: TWO_WEEKS_BEFORE_TODAY,
    },
  ],
  [GroupedTalentDictionaryKey.RECENTLY_ACTIVE]: [
    {
      operator: SearchEntityTagOperatorEnum.GT,
      tag: UserSearchEntityTagNameEnum.SESSION_STARTED_AT,
      value: TWO_WEEKS_BEFORE_TODAY,
    },
    {
      operator: SearchEntityTagOperatorEnum.LT,
      tag: UserSearchEntityTagNameEnum.VERIFICATION_PUBLISHED_AT,
      value: TWO_WEEKS_BEFORE_TODAY,
    },
  ],
};

export const REJECTED_TALENTS_VARIABLES: GetRejectedGroupedTalentsQueryVariables = {
  dateRangeInput: {
    start: SEVEN_DAYS_BEFORE_TODAY,
  },
};
